/* 
These communication settings apply to both notification and direct content communications. The following communication settings are per communication object:
*/

import { runDatabaseFunction } from "../../helpers/HttpHelper";
import CommunicationSettings from "../config/CommunicationSettings/CommunicationSettings";
import { countries } from "../../components/localization/LanguageSelector";

class Communication {
  id: number;
  communication_set_id: number | null;
  start: string; //An interval of time consisting of an integer and a unit. Can be written as a percentage, which means the day in the interaction active period which is that percentage of the way from the start to the end day of the active period.
  end: string; //An interval of time consisting of an integer and a unit. Can be written as a percentage, which means the day in the interaction active period which is that percentage of the way from the start to the end day of the active period.
  properties: CommunicationSettings;
  modified: string;
  ref: string | undefined;
  justAdded: boolean | undefined;

  constructor(
    id: number,
    communication_set_id: number | null,
    start: string,
    end: string,
    properties: CommunicationSettings,
    modified: string,
    ref?: string | undefined,
    justAdded?: boolean | undefined
  ) {
    this.id = id;
    this.communication_set_id = communication_set_id;
    this.start = start;
    this.end = end;
    this.properties = properties;
    this.modified = modified;
    this.ref = ref;
    this.justAdded = justAdded;
  }

  // remove subject and body from app and sms
  // remove text from email
  public static cleanup = (communication:Communication) =>{
    countries.forEach((country)=>{
      const lang = country.language ? country.language + '' : ''
      if(communication.properties.message.app ){
        delete communication.properties.message.app[lang]?.subject
        delete communication.properties.message.app[lang]?.body
      }

      if(communication.properties.message.sms){
        delete communication.properties.message.sms[lang]?.subject
        delete communication.properties.message.sms[lang]?.body
      }

      if(communication.properties.message.email){
        delete communication.properties.message.email[lang]?.text
      }
    })
    return communication
  }

  public static getPriorities = async () =>{
    let priorities : any= [];
    const dbFunc = "fn_get_priority_values";
    try {
      priorities = await runDatabaseFunction(dbFunc,{})
      // TODO - NEED TO UPDATE THE NODES IN REDUX AS WELL, IN A SIMILAR WAY
    } catch (err: any) {
      console.error("Error with update_interaction_set_id: " + err);
      return priorities
    }
    return priorities
  }

  public static copy = async (communication_id:number) =>{
    let newCommunicationCopy : any= {};
    const dbFunc = "fn_copy_communication";
    try {
      newCommunicationCopy = await runDatabaseFunction(dbFunc,{communication_id:communication_id})
      // TODO - NEED TO UPDATE THE NODES IN REDUX AS WELL, IN A SIMILAR WAY
    } catch (err: any) {
      console.error("Error with fn_copy_communication: " + err);
      return {}
    }
    newCommunicationCopy = await newCommunicationCopy.json()
    return newCommunicationCopy
  }
}

export default Communication;
